import {
	REQUEST_CREATE_CUSTOM,
	REQUEST_CREATE_CUSTOM_FAILURE,
	REQUEST_CREATE_CUSTOM_SUCCESS,
	REQUEST_CREATE_ITEM,
	REQUEST_CREATE_ITEM_FAILURE,
	REQUEST_CREATE_ITEM_SUCCESS,
	REQUEST_LOAD_ITEM,
	REQUEST_LOAD_ITEM_FAILURE,
	REQUEST_LOAD_ITEM_SUCCESS,
} from './optionalProgramItems.actionTypes';

export const actionCreators = {
	doLoadItem: (key: string) => ({
		type: REQUEST_LOAD_ITEM,
		key,
	}),
	doLoadItemSuccess: (key: string, contents: any) => ({
		type: REQUEST_LOAD_ITEM_SUCCESS,
		key,
		contents,
	}),
	doLoadItemFailure: (error: Error) => ({
		type: REQUEST_LOAD_ITEM_FAILURE,
		error,
	}),
	doCreateItem: (programItemId: string, contentType: string, externalId: string, dayNumber: number) => ({
		type: REQUEST_CREATE_ITEM,
		programItemId,
		contentType,
		externalId,
		dayNumber,
	}),
	doCreateItemSuccess: (contents: Object) => ({
		type: REQUEST_CREATE_ITEM_SUCCESS,
		contents,
	}),
	doCreateItemFailure: (error: Error) => ({
		type: REQUEST_CREATE_ITEM_FAILURE,
		error,
	}),
	doCreateCustomFromOptional: (
		contentType: string, // atm. workout only
		programItemExternalId: string,
		exerciseExternalId: string,
		duration: number,
		met: number,
		dayNumber: number
	) => ({
		type: REQUEST_CREATE_CUSTOM,
		contentType, // atm. workout only
		programItemExternalId,
		exerciseExternalId,
		duration,
		met,
		dayNumber,
	}),
	doCreateCustomFromOptionalSuccess: (contents: any) => ({
		type: REQUEST_CREATE_CUSTOM_SUCCESS,
		contents,
	}),
	doCreateCustomFromOptionalFailure: (error: Error) => ({
		type: REQUEST_CREATE_CUSTOM_FAILURE,
		error,
	}),
};

export type OptionalProgramItemsActionType =
	| ReturnType<typeof actionCreators.doLoadItem>
	| ReturnType<typeof actionCreators.doLoadItemSuccess>
	| ReturnType<typeof actionCreators.doLoadItemFailure>;
